module.exports = __webpack_public_path__ + "img/01-10.f0ba7a98.png";